import { onGlobalVarSet } from '@mm/utils';

// Note: Unfortunately OneSignal does not offer TS
// support yet despite having their code in TS.
type OneSignal = any;

export const initOneSignal = async () => {
  if (!ONE_SIGNAL_WEB_PUSH_APP_ID) return;

  const OneSignal = (await onGlobalVarSet<OneSignal>('OneSignal')) || [];
  OneSignal.push(() =>
    OneSignal.init({
      appId: ONE_SIGNAL_WEB_PUSH_APP_ID,
      autoResubscribe: true,
      path: '/',
      persistNotification: false,
    }),
  );
};
